import Vue from "vue";
import base from "../../baseMarketing";

export default {
  ...base,
      
  apiUrl: '',
  API_SERVICE: '/marketing/dns',

  async get({ domainId }) {
    const url = this.userUrl({ path: `/domain/${domainId}` });

    return Vue.http.get(url);
  },

  async authenticate({ domain, subdomain }) {
    const url = this.userUrl({ path: `/domain/authenticate` });

    return Vue.http.post(url, {
      domain,
      subdomain,
    });
  },

  async list() {
    const url = this.userUrl({ path: `/domain/list` });

    return Vue.http.get(url);
  },

  async validate({ domainId }) {
    const url = this.userUrl({ path: `/domain/${domainId}/validate` });

    return Vue.http.get(url);
  },

  async delete({ domainId }) {
    const url = this.userUrl({ path: `/domain/${domainId}` });

    return Vue.http.delete(url);
  }
};